<template>
  <IconSvgBase :class="$style.icon" :view-width="12" :view-height="12">
    <path
      d="M8.67861 5.11944L6.88195 3.32278L8.18061 2.02344L9.97661 3.81944L8.67861 5.11944ZM4.05261 9.75011L2.06795 9.93077L2.24395 7.96011L5.98861 4.21544L7.78595 6.01277L4.05261 9.75011ZM10.9353 2.89211L10.9346 2.89144L9.10928 1.06611C8.61528 0.573442 7.76661 0.550109 7.29861 1.02011L1.30128 7.01744C1.08395 7.23411 0.94928 7.52211 0.92128 7.82677L0.668613 10.6068C0.65128 10.8034 0.72128 10.9981 0.86128 11.1381C0.98728 11.2641 1.15728 11.3334 1.33261 11.3334C1.35328 11.3334 1.37328 11.3328 1.39328 11.3308L4.17328 11.0781C4.47861 11.0501 4.76595 10.9161 4.98261 10.6994L10.9806 4.70144C11.4659 4.21478 11.4453 3.40278 10.9353 2.89211Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconPen',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;
  fill: currentcolor;
}
</style>
